<script setup lang="ts">
import { useI18n } from '@/composable/useI18n'
import { useGroupStore } from '@/store/group'
import { onMounted } from 'vue'
import ReportSearchPanel from './ReportSearchPanel.vue'
import SharePopover from './SharePopover.vue'

const { t } = useI18n()
const { fetch: fetchGroups } = useGroupStore()

onMounted(() => {
  fetchGroups()
})
</script>

<template>
  <div class="flex min-w-0 w-full flex-col p-6 lg:px-8">
    <div class="mb-4 flex flex-col sm:flex-row sm:items-center sm:justify-between">
      <div class="mb-4 flex max-w-lg flex-col sm:mb-0 sm:mr-4 sm:max-w-none">
        <h1 class="pb-4 text-title-md2 font-semibold text-black">
          {{ t('report.header.title') }}
        </h1>
        <p class="max-w-prose text-left text-sm font-medium leading-relaxed text-body">
          {{ t('report.header.subtitle') }}
        </p>
      </div>

      <div class="hidden shrink-0 items-center justify-center xl:flex">
        <SharePopover />
      </div>
    </div>

    <ReportSearchPanel />
  </div>
</template>
